module.exports = __webpack_public_path__ + "img/0S6A96344.026a12cd.jpg";